import Vue from 'vue';
import Vuex from 'vuex';
import loader from './loader';
import clients from './clients';
import scopeflows from './scopeflows';
import groups from './groups';
import errors from './errors';
import user from './user';
import shipment from './shipment';
import languages from './languages';
import deliveries from './deliveries';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		loader,
		clients,
		scopeflows,
		groups,
		errors,
		user,
		shipment,
		languages,
		deliveries
	}
});
